import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';

const StyledGraphComponent = styled.div`
  position: relative;
  background: white;
  padding-bottom: 30px;
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const GraphWrapper = styled.div`
  position: relative;
  background: white;
  padding-bottom: 30px;
  width: 100%;
  height: ${props => (props.heightInPx ? `${props.heightInPx}px` : '600px')};
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

class GraphComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    srcDoc.set(this.iframeRef.current, this.props.data); // eslint-disable-line no-script-url, no-undef
  }

  render() {
    const { title, info } = this.props;
    return (
      <StyledGraphComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <GraphWrapper heightInPx={this.props.heightInPx}>
          <iframe
            ref={this.iframeRef}
            title={`Title${parseInt(Math.random() * 100000, 10)}`}
            style={{
              width: '100%',
              height: '100%',
              border: 0
            }}
          />
          <UpdatedDate>{`letztes Update: ${
            this.props.lastUpdated
          }`}</UpdatedDate>
        </GraphWrapper>
      </StyledGraphComponent>
    );
  }
}

export default GraphComponent;
